<script setup lang="ts">
  import { useAgencyStructureSelectors } from '../../composables/useAgencyStructureSelectors'
  import AgencyListItem from './AgencyListItem.vue'
  import AgencyRootNodeListItem from './AgencyRootNodeListItem.vue'

  // Router-agnostic structure body shared by the routed AgencyStructureView
  // (under its PageLayout chrome) and the AdministrationModal agency-structure
  // panel. The host owns the Active / Inactive tab state and surrounding
  // header; what an agency-row click does (route navigation vs. opening the
  // detail modal) is decided by the optional `agencyNodeSelectKey` strategy the
  // host provides. This component only renders the active tree or the inactive
  // list for the given tab.
  defineProps<{
    /** `agency-structure` shows the active tree; anything else, the inactive list. */
    activeTab: string
  }>()

  const { inactiveAgencies } = useAgencyStructureSelectors()
</script>

<template>
  <div class="flex flex-col">
    <div
      v-if="activeTab === 'deactivated-agencies'"
      class="flex flex-col divide-y divide-neutral-200 overflow-hidden rounded-md dark:divide-neutral-700"
    >
      <AgencyListItem
        v-for="agency in inactiveAgencies"
        :key="agency.id"
        :agency-node="agency"
      />
    </div>
    <AgencyRootNodeListItem v-else />
  </div>
</template>
